import { FindPatientsForEventDto } from '../sdk'
import { extractPnrCandidates, stripPnrCandidates } from './pnr'

// /user-admin/find-for-event isn't paginated, so a very short term (e.g. "a"
// or "19") would list most patients - wait for something more specific.
export const MIN_NAME_SEARCH_LENGTH = 2
export const MIN_PNR_SEARCH_DIGITS = 6

// Matches FindPatientsForEventDto.searchTerm's max length on the API.
const MAX_SEARCH_TERM_LENGTH = 100

function isSearchableTerm(term: string): boolean {
  const isPnrFragment = /^[\d\s+-]+$/.test(term)
  return isPnrFragment
    ? term.replace(/\D/g, '').length >= MIN_PNR_SEARCH_DIGITS
    : term.length >= MIN_NAME_SEARCH_LENGTH
}

// Turns what was typed into the event modal's patient search into a /user-admin/find-for-event query
export function buildPatientSearchQuery(input: string): FindPatientsForEventDto | null {
  const personalNumbers = Array.from(new Set(extractPnrCandidates(input)))
  const rest = stripPnrCandidates(input).slice(0, MAX_SEARCH_TERM_LENGTH)
  const searchTerm = isSearchableTerm(rest) ? rest : undefined

  if (personalNumbers.length === 0 && !searchTerm) return null
  return { personalNumbers, searchTerm }
}
